import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import React, { useState } from "react";

// Style
import "./RadioButtonListOptions.scss";

const RadioButtonListOptions = ({
  category,
  filterCategories,
  setFilterCategories,
  activeCategory,
  showSearchOption,
}) => {
  const [optionSearchString, setOptionsSearchString] = useState("");

  const handleOptionSelected = (value) => {
    setFilterCategories((categories) => {
      categories[activeCategory].tempSelectedValue = value;
      categories[activeCategory].tempFilterCount = 1;
      return [...categories];
    });
  };

  const handleClearSelection = () => {
    setFilterCategories((categories) => {
      categories[activeCategory].tempSelectedValue = null;
      categories[activeCategory].tempFilterCount = 0;
      return [...categories];
    });
  };

  return (
    <div className="radio-list-options-container">
      {showSearchOption ? (
        <div className="top">
          <input
            type="text"
            maxLength="300"
            placeholder={`Search ${category.name}`}
            onChange={(e) => setOptionsSearchString(e.target.value)}
            value={optionSearchString}
          />
        </div>
      ) : null}

      <div className="bottom">
        <div className="title-clear">
          <span className="title">{category.name}</span>
          <span className="clear" onClick={handleClearSelection}>
            Clear
          </span>
        </div>
        {category.options.map(({ id, isSelected, isSelectedTemp, name }) =>
          name
            .toLowerCase()
            .includes(optionSearchString.trim().toLowerCase()) ? (
            <div className="radio-item" key={id}>
              <FormControlLabel
                aria-label="Select All"
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                control={
                  <Radio
                    checked={category.tempSelectedValue === name}
                    onChange={(e) => handleOptionSelected(e.target.value)}
                    disableRipple={true}
                    value={name}
                    className="accordion-radio"
                    size="small"
                    name={category.id}
                  />
                }
                label={name}
              />
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default RadioButtonListOptions;
